<script lang="ts">
	import type { Connector, Spot } from '../../../types';
	import * as m from '$paraglide/messages';
	import Icon from '../../../../icons/Icon.svelte';
	import { connectorTypeToIconNameMap, DIVIDER_FOR_W_TO_KW } from '../../../constants';

	interface Props {
		connectors?: Connector[];
	}

	const { connectors = [] }: Props = $props();

	// TODO: Move this in BFF when we fetch the real data
	function sortSpotsByPower(a: Spot, b: Spot) {
		return b.power - a.power;
	}

	const sortedConnectors = $derived(connectors.map(connector => ({
		...connector,
		spots: [...connector.spots].sort(sortSpotsByPower),
	})));
</script>

<div class="mb-4">
	{#each sortedConnectors as connector (connector.type)}
		<div class="connector mb-2">
			<div class="font-bold text-sm flex items-center mb-2">
				<Icon
					icon={connectorTypeToIconNameMap[connector.type]}
					ariaLabel={connector.name}
					class="text-8 mr-1"
				/>
				{connector.name}
			</div>
			<div>
				{#each connector.spots as spot (spot.power)}
					<div class="text-sm inline-flex mr-1">
						<span class="bg-electric-weakest p-1 rd-l-1">
							{spot.count === 1
								? m.ev_spots__one()
								: m.ev_spots__many({
									count: spot.count,
								})}
						</span>
						<span class="bg-electric text-neutral-weakest text-bold p-1 rd-r-1">
							{spot.power / DIVIDER_FOR_W_TO_KW} kW
						</span>
					</div>
				{/each}
			</div>
		</div>
	{/each}
</div>

<style>
	.connector:not(:last-of-type) {
		--uno: border-neutral-weak border-b-1 border-b-solid;
	}
</style>
